@if (patientAttachment.duplicatePatientAttachment) {
  <span>
    [<span class="duplicate">DUPLICATE</span>]
  </span>
}
